import React from 'react';
import { ModuleInterface } from '../types';
import Switch from 'components/Form/Switch';
import { useT } from 'hooks/Locale/useT';

interface SwitchFieldProps extends ModuleInterface {}

/** Boolean toggle for the generic Filter modal. */
const SwitchField: React.FC<SwitchFieldProps> = ({ layout, ...field }) => {
    const t = useT();

    return (
        <Switch
            isFormItem
            name={field.name}
            label={t(field.label)}
            customLayout={layout as {labelCol?: {span: number}; wrapperCol?: {span: number}}}
        />
    );
};

export default SwitchField;
